import Vue from 'vue'
import Vuex from 'vuex'
import admin from './modules/admin'
import atributos from './modules/atributos'
import categories from './modules/categories'
import categoryType from './modules/categoryType'
import client from './modules/client'
import clientes from './modules/clientes'
import colors from './modules/colors'
import copy from './modules/copy'
import gallery from './modules/gallery'
import info from './modules/info'
import logo from './modules/logo'
import main from './modules/main'
import mainmtr from './modules/mainmtr'
import marcas from './modules/marcas'
import personalizacion from './modules/personalizacion'
import productos from './modules/productos'
import proyectos from './modules/proyectos'
import related from './modules/related'
import review from './modules/review'
import reviews from './modules/reviews'
import secciones from './modules/secciones'
import slides from './modules/slides'
import sociales from './modules/sociales'
import statistics from './modules/statistics'
import storeOnline from './modules/storeOnline'
import suscripciones from './modules/suscripciones'
import usuarios from './modules/usuarios'
import jobs from './modules/jobs'
import cart from './modules/cart'
import quotation from './modules/quotation'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    admin,
    atributos,
    categories,
    categoryType,
    client,
    clientes,
    colors,
    copy,
    gallery,
    info,
    logo,
    main,
    mainmtr,
    marcas,
    personalizacion,
    productos,
    proyectos,
    related,
    review,
    reviews,
    secciones,
    slides,
    sociales,
    statistics,
    storeOnline,
    suscripciones,
    usuarios,
    jobs,
    cart,
    quotation
  }
})
